/**
 * Rewrites Open edX Learning MFE URLs onto Ampela `/preview/...` routes.
 * Studio "View Live" historically used LMS jump_to → `/app/course/:id/:seq/:unit`.
 */
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import Skeleton from "react-loading-skeleton";

/**
 * Sends staff to the Ampela preview gate for a course (and optional vertical block).
 */
export default function LearningMfeRedirect() {
  const { courseId, verticalId, blockId } = useParams();
  const navigate = useNavigate();
  const targetBlock = verticalId || blockId || "";

  useEffect(() => {
    if (!courseId) {
      navigate("/dashboard", { replace: true });
      return;
    }
    const path = targetBlock ? `/preview/${courseId}/${targetBlock}` : `/preview/${courseId}`;
    navigate(path, { replace: true });
  }, [courseId, targetBlock, navigate]);

  return (
    <Box className="m-0 md:m-6 flex-1 flex justify-center items-center">
      <Skeleton containerClassName="w-8/12" className="h-10 mt-3 w-full" count={3} />
    </Box>
  );
}
